import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";

const Titulo = styled.p`
    margin: 0 0 8px 0;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
`;
const Valor = styled.p`
    margin: 0;
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #f8fafc;
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    min-height: 20px;
`;

const ModalCelulaInfo = ({ titulo, valor, onClose }) => {

    return (
        <Overlay state={true} changeContent={onClose}>
            <Modal header={true} close={onClose} size="sm">
                <Titulo>{titulo}</Titulo>
                <Valor>{valor || "—"}</Valor>
            </Modal>
        </Overlay>
    )

}

export default ModalCelulaInfo;
